// extracted by mini-css-extract-plugin
export default {"template-icon":"TemplateMsgItem_template-icon__A14nX","templateItem":"TemplateMsgItem_templateItem__FcCj7","category-translation":"TemplateMsgItem_category-translation__DR7Zq"};